export const refreshCart = (data) => {
    return {
        type: 'REFRESH_CART',
        payload: data
    }
}